import { useEffect, useState } from 'react'
import { css } from '@firebolt-dev/css'

export function FileArea({ accept, onFile }) {
  const [n, setN] = useState(0)
  useEffect(() => {
    console.log('bah')
    return () => {
      console.log('humbug')
    }
  }, [])
  return (
    <input
      key={n}
      css={css`
        position: absolute;
        top: -9999px;
        left: -9999px;
        opacity: 0;
        overflow: hidden;
      `}
      type='file'
      accept={accept}
      onChange={async e => {
        console.log('wtf')
        try {
          const file = e.target.files && e.target.files[0]
          console.log('meow', file)
          if (!file) return
          onFile(file)
        } catch (err) {
          console.error('Import failed:', err)
        } finally {
          // reset input so the same file can be chosen again
          setN(x => x + 1)
        }
      }}
    />
  )
}
